import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { showMessageModal } from 'src/actions/frontend'
import { eventSelector, invitationSelector, userSelector, usersSelector } from 'src/selectors'

import GuestListRow from './GuestListRow'

function mapDispatchToProps (dispatch) {
  return {
    onShowMessageModal: () => {
      const data = {
        title: 'To Chat, Get the App',
        subTitle: 'Hobnob makes group chats pain-free and private! Download Hobnob to direct message any guest on the guest list.'
      }
      dispatch(showMessageModal(data))
    }
  }
}

function mapStateToProps (state, ownProps) {
  const { invitation, user } = ownProps
  const currentUserInvitation = invitationSelector(state)
  const event = eventSelector(state)
  const users = usersSelector(state)
  const currentUser = userSelector(state)
  const { child_count_enabled, guest_count_enabled, ticketing_enabled_at } = event

  const ownInvitation = currentUsersInvitation(invitation, currentUserInvitation, currentUser)
  const invitationUser = user || (invitation && users[invitation.guest])
  const verifiedUser = invitationUser && invitationUser.app_user
  const canMessage = !!verifiedUser || (!!invitation && invitation.contact_method.type === 'PhoneNumberContactMethod')

  return {
    canMessage,
    childCountEnabled: child_count_enabled || (!!ticketing_enabled_at && invitation && !!invitation.child_count),
    guestCountEnabled: guest_count_enabled,
    invitationUser: user || (invitation && users[invitation.guest]),
    ownInvitation
  }
}

function currentUsersInvitation (invitation, currentUserInvitation, currentUser) {
  if (!invitation) return false
  const invitationIdMatch = currentUserInvitation && currentUserInvitation.id === invitation.id
  const invitationUserIdsMatch = currentUser && currentUser.id === invitation.guest
  return invitationIdMatch || invitationUserIdsMatch
}

export const GuestListRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestListRow)
export default GuestListRowContainer

GuestListRowContainer.propTypes = {
  invitation: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/guest_list/GuestListRowContainer.jsx